import React,{useEffect} from "react";
import { useLoading } from "../Loading";

function AboutUs() {
    const {setLoading} = useLoading();
    useEffect(()=>{
                  setTimeout(() => {
                      setLoading(false);
                  }, 50);
              },[]);

    return (
        <div className="aboutUsContainer">
            <div className="firstContainer">
                <div className="aboutUsText">
                    <h1>About Us</h1>
                    <h2>Connecting Hearts, One Paw at a Time.</h2>
                    <p>At Pawtner, we make pet adoption easier,
                        helping animals find loving homes while supporting shelters and communities.</p>
                </div>
                <img src="/aboutUs.jpeg" alt="about us"></img>
            </div>
            <h1 className="stepTitle">Adoption Process Step</h1>
            <div className="aboutUsProcessContainer">
                <div className="processImg"><img src="/apply.png" alt="apply adoption" /><span>Apply and Schedule Visit <br></br>within 2 weeks</span></div>
                <div className="processImg"><img src="/meet.png" alt="meet with shelter" /><span>Meet Shelter and wait for<br></br> Final Decision</span></div>
                <div className="processImg"><img src="/take.png" alt="take pet home" /><span>Take Pet Home</span></div>
            </div>
            <div className="introductionContainer">
                <h2>Who We Are</h2>
                <p style={{marginBottom:"3%"}}>At Pawtner, we believe that every pet deserves a loving home. 
                    We are dedicated to connecting rescue animals with compassionate adopters, 
                    making the process easy, transparent, and meaningful. 
                    Our platform partners with animal shelters and rescue organizations to provide a second chance to pets in need.</p>
            </div>
            <div  className="introductionContainer">
                <h2>Our Mission</h2>
                <p>🐾 To reduce pet homelessness by making adoption simple and accessible.</p>
                <p>🐾 To support animal shelters by providing tools to manage adoption applications and volunteer opportunities.</p>
                <p style={{marginBottom:"3%"}}>🐾 To educate the public on responsible pet ownership, animal welfare, and the importance of adoption.</p>
            </div>
            <div className="introductionContainer">
                <h2>Our Vision</h2>
                <p style={{marginBottom:"3%"}}> We envision a world where every pet has a home and no animal is left behind. 
                    By leveraging technology and community engagement, 
                    we aim to create a future where shelters are no longer overcrowded, 
                    and pet adoption is the first choice for families.</p>
            </div>
            <div className="secondContainer">
            <img src="/contactUs.jpg" alt="contact us"></img>
                <div className="contactUsText">
                    <h1>Contact Us</h1>
                    <p>We are dedicated to supporting animal shelters and rescue organizations in their mission to save and find loving homes for pets in need. 
                        Contact us to get to know the passionate team behind our cause.</p>
                    <button className="contactBtn" onClick={() => window.location.href = "mailto:pawtner1234@gmail.com"} >Email</button>
                </div>
            </div>
        </div>
    );

}

export default AboutUs;